export const getTrimmedContent = (content) => {
  return content
    ?.replace(/<!--[\s\S]*?-->/g, "")
    ?.replace(/^(\W*<p>)|(<\/p>\W*)$/g, "")
}
